import type { HumanMember } from "@/features/containers/containers.types";
import { isMemberType } from "@/features/containers/containers.utils";

export function getHumanDisplayName(member: HumanMember): string {
  if (isMemberType("user")(member)) {
    return (
      `${member.profile_first_name ?? ""} ${member.profile_last_name ?? ""}`.trim() ||
      member.profile_email
    );
  }
  return member.invite_email || member.invite_domain || "Invited user";
}

export function getHumanSubtitle(member: HumanMember): string {
  if (isMemberType("user")(member)) {
    return member.profile_email;
  }
  return member.invite_email || member.invite_domain || "Pending invite";
}
